import { defineStore } from 'pinia'

const ACCESS_TOKEN_KEY = 'mallAccessToken'
const REFRESH_TOKEN_KEY = 'mallRefreshToken'
const USER_KEY = 'mallUser'

function parseJwtPayload(token) {
  try {
    const payload = token.split('.')[1]
    if (!payload) return null
    const normalized = payload.replace(/-/g, '+').replace(/_/g, '/')
    const padded = normalized.padEnd(normalized.length + (4 - normalized.length % 4) % 4, '=')
    return JSON.parse(decodeURIComponent(escape(atob(padded))))
  } catch {
    return null
  }
}

function isTokenExpired(token) {
  const payload = parseJwtPayload(token)
  if (!payload?.exp) return true
  return payload.exp * 1000 <= Date.now()
}

export const useAuthStore = defineStore('auth', {
  state: () => ({
    accessToken: localStorage.getItem(ACCESS_TOKEN_KEY) || '',
    refreshToken: localStorage.getItem(REFRESH_TOKEN_KEY) || '',
    user: JSON.parse(localStorage.getItem(USER_KEY) || 'null'),
  }),
  getters: {
    isLoggedIn: state => Boolean(state.accessToken) && !isTokenExpired(state.accessToken),
  },
  actions: {
    isAccessTokenExpired() {
      return !this.accessToken || isTokenExpired(this.accessToken)
    },
    saveSession(payload) {
      this.accessToken = payload.accessToken || ''
      this.refreshToken = payload.refreshToken || ''
      this.user = {
        userCode: payload.userCode,
        userEmail: payload.userEmail,
        userName: payload.userName,
      }
      localStorage.setItem(ACCESS_TOKEN_KEY, this.accessToken)
      localStorage.setItem(REFRESH_TOKEN_KEY, this.refreshToken)
      localStorage.setItem(USER_KEY, JSON.stringify(this.user))
    },
    clearSession() {
      this.accessToken = ''
      this.refreshToken = ''
      this.user = null
      localStorage.removeItem(ACCESS_TOKEN_KEY)
      localStorage.removeItem(REFRESH_TOKEN_KEY)
      localStorage.removeItem(USER_KEY)
    },
    updateUser(payload) {
      this.user = {
        ...(this.user || {}),
        ...payload,
      }
      localStorage.setItem(USER_KEY, JSON.stringify(this.user))
    },
  },
})
